import { endpoint } from "../utils/endpoint";
import { axiosGet } from "./axiosRequests";

const pmMonthlySnapshotsEndpoint = endpoint("app/v1.0/pm_monthly_snapshots");

export interface ICompanyPmMonthlySnapshotPayload {
  month?: string;
}

export const getPmMonthlySnapshots = async (payload: ICompanyPmMonthlySnapshotPayload = {}) => {
  const response = await axiosGet(
    pmMonthlySnapshotsEndpoint,
    payload,
  );

  return response.data.data;
};

export default {
  getPmMonthlySnapshots,
};
